<template>
  <div>
    <el-dialog
      title="贷款详情"
      :visible.sync="dialogVisible"
      top="5%"
      width="1100px"
      @close="handleClose"
    >
      <div class="loan-detail-container">
        <!-- 左侧基本信息 -->
        <div class="left-section">
          <div class="info-group">
            <div class="info-item">
              <span class="info-label">贷款主体</span>
              <span class="info-value">{{ loanInfo?.name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">统一社会信用代码</span>
              <span class="info-value">{{ loanInfo?.idCardNo }}</span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-item">
              <span class="info-label">法人姓名</span>
              <span class="info-value">{{ loanInfo?.legalPersonName }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">法人身份证号</span>
              <span class="info-value">{{ loanInfo?.legalPersonNo }}</span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-item">
              <span class="info-label">联系人</span>
              <span class="info-value">{{ loanInfo?.contactName }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">联系电话</span>
              <span class="info-value">{{ loanInfo?.contactPhone }}</span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-item">
              <span class="info-label">银行账号</span>
              <span class="info-value">{{ loanInfo?.bankAccount }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">开户行</span>
              <span class="info-value">{{ loanInfo?.bankName }}</span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-item">
              <span class="info-label">贷款产品</span>
              <span class="info-value">{{ loanInfo?.title }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">所属银行</span>
              <span class="info-value">{{ loanInfo?.bankName }}</span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-item">
              <span class="info-label">质押仓单</span>
              <span class="info-value">{{ loanInfo?.warehouseCode || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">质押数量(KG)</span>
              <span class="info-value">{{ loanInfo?.warehouseNumber }}</span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-item">
              <span class="info-label">贷款金额（元）</span>
              <span class="info-value">{{ loanInfo?.money }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">贷款期限(月)</span>
              <span class="info-value">{{ loanInfo?.loanTerm }}</span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-item full-width">
              <span class="info-label">贷款用途说明</span>
              <span class="info-value">{{ loanInfo?.use }}</span>
            </div>
          </div>

          <!-- 附件资料 -->
          <div class="attachment-section">
            <h3>附件资料</h3>
            <div class="attachments">
              <div class="attachment-item">
                <img
                  :src="baseUrl + 'admin/file/get?ossFilePath=' + loanInfo?.licenseImg"
                  alt="营业执照"
                  class="attachment-img"
                />
              </div>
              <div class="attachment-item">
                <img
                  :src="baseUrl + 'admin/file/get?ossFilePath=' + loanInfo?.userCardFrontImg"
                  alt="人像面"
                  class="attachment-img"
                />
              </div>
              <div class="attachment-item">
                <img
                  :src="baseUrl + 'admin/file/get?ossFilePath=' + loanInfo?.userCardBackImg"
                  alt="国徽面"
                  class="attachment-img"
                />
              </div>
            </div>
            <div class="attachment-files">
              <div class="textContent" v-if="loanInfo?.files">
                <div class="Item" v-for="(item, index) in JSON.parse(loanInfo?.files)" :key="index">
                  <!-- 图片文件 -->
                  <div v-if="isImageFile(item.FilesName)" class="image-container">
                    <el-image
                      :src="'/api/admin/file/get?ossFilePath=' + item.imgUrl"
                      class="file-image"
                      :preview-src-list="['/api/admin/file/get?ossFilePath=' + item.imgUrl]"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <el-button
                      type="text"
                      size="small"
                      class="download-btn"
                      @click="downloadFile(item.imgUrl, item.FilesName)"
                      title="下载文件"
                    >
                      <i class="el-icon-download"></i>
                      下载
                    </el-button>
                  </div>

                  <!-- PDF文件 -->
                  <div v-else-if="isPdfFile(item.FilesName)" class="file-container">
                    <div class="pdf-file-item" title="PDF文件">
                      <i class="el-icon-document"></i>
                    </div>
                    <div class="file-actions">
                      <el-button
                        type="text"
                        size="small"
                        @click="viewPdfFile(item.imgUrl, item.FilesName)"
                        title="查看文件"
                      >
                        <i class="el-icon-view"></i>
                        查看
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        @click="downloadFile(item.imgUrl, item.FilesName)"
                        title="下载文件"
                      >
                        <i class="el-icon-download"></i>
                        下载
                      </el-button>
                    </div>
                  </div>

                  <!-- 其他文件类型 -->
                  <div v-else class="file-container">
                    <div class="other-file-item" title="文件">
                      <i class="el-icon-document-copy"></i>
                    </div>
                    <el-button
                      type="text"
                      size="small"
                      class="download-btn"
                      @click="downloadFile(item.imgUrl, item.FilesName)"
                      title="下载文件"
                    >
                      <i class="el-icon-download"></i>
                      下载
                    </el-button>
                  </div>
                </div>
              </div>
              <div v-else class="textContent">暂无附件</div>
            </div>
          </div>
        </div>

        <!-- 右侧贷款结果 -->
        <div class="right-section">
          <h3>贷款结果</h3>
          <div class="result-info">
            <div class="result-item">
              <span class="result-label">通过额度(元)</span>
              <span class="result-value">{{ loanInfo?.approveMoney }}</span>
            </div>

            <div class="result-item">
              <span class="result-label">贷款期限(月)</span>
              <span class="result-value">{{ loanInfo?.loanTerm }}</span>
            </div>

            <div class="result-item">
              <span class="result-label">放款账户</span>
              <span class="result-value highlight">{{ loanInfo?.bankAccount }}</span>
            </div>

            <div class="result-item">
              <span class="result-label">账户名称</span>
              <span class="result-value highlight">{{ loanInfo?.bankAccountName }}</span>
            </div>

            <div class="result-item">
              <span class="result-label">开户行</span>
              <span class="result-value highlight">{{ loanInfo?.bankName }}</span>
            </div>

            <div class="result-item" style="margin-bottom: 35px;" v-if="actionType == 'process'">
              <span class="result-label">剩余本金(元)</span>
              <span class="result-value highlight">{{ loanInfo?.remainingAmount }}</span>
            </div>

            <!-- 状态信息 -->
            <div v-if="actionType === 'view'" class="status-section">
              <div v-if="selectedLoanRow?.taskStatus == 1" class="status-approved">
                <span class="status-icon">✓</span>
                <span class="status-text">已通过</span>
              </div>
              <div v-if="selectedLoanRow?.taskStatus == 2" >
                <div class="status-rejected">
                  <span class="status-icon">✗</span>
                  <span class="status-text">已退回</span>
                </div>
                <div class="reject-reason">
                  原因：{{ '222222 sssssssssssssssssssssssssssssssssssssssssssssssss' }}
                </div>
              </div>
            </div>
            <!-- 操作按钮 - 只在处理模式下显示 -->
            <div v-if="actionType === 'process'" class="action-buttons">
              <el-button type="danger" @click="handleRejectClick">退回</el-button>
              <el-button type="success" @click="handleApproveClick">通过</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- PDF查看器弹窗 -->
    <el-dialog
      :title="`PDF查看-${pdfFileName}`"
      :visible.sync="pdfVisible"
      width="90%"
      height="90%"
      :modal-append-to-body="true"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="closePdfViewer"
      append-to-body
    >
      <div class="pdf-view-container">
        <div v-if="pdfSrc" class="pdf-content">
          <div class="content" v-for="page in pdfTotalPages" :key="page">
            <pdf :src="pdfSrc" :page="page" class="pdf-page"></pdf>
          </div>
        </div>
        <div v-else class="pdf-loading">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
      </div>
    </el-dialog>

    <ProDialog
      ref="proDialogRef"
      title="退回原因"
      :fields="fields"
      :formData.sync="rejectForm"
      :rules="rejectRules"
      width="400px"
      labelWidth="0"
      :onConfirm="handleConfirm"
    ></ProDialog>
  </div>
</template>

<script>
import { operateDetails } from '@/api/RuralFinance'
import pdf from 'vue-pdf-signature'
import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory.js'
import { approvalRepayment } from '@/api/taskProcessing'
import ProDialog from '@/components/dialog/ProDialog.vue'

export default {
  name: 'LoanDetailDialog',
  components: {
    pdf,
    ProDialog
  },
  props: {
    selectedLoanRow: {
      type: Object,
      default: null
    },
    actionType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loanInfo: {},
      baseUrl: window.globalUrl.HOME_API,

      // PDF查看相关状态
      pdfVisible: false,
      pdfSrc: '',
      pdfFileName: '',
      pdfTotalPages: 0,

      // 退回原因弹窗相关状态
      rejectForm: {
        reason: ''
      },
      rejectRules: {
        reason: [{ required: true, message: '请输入退回原因', trigger: 'blur' }]
      }
    }
  },
  computed: {
    fields() {
      return [
        {
          prop: 'reason',
          type: 'textarea',
          editable: true,
          props: {
            type: 'textarea',
            placeholder: '请输入退回原因',
            rows: 4
          }
        }
      ]
    }
  },
  methods: {
    async init() {
      let applyId = this.selectedLoanRow.applyId
      // let applyId = '1000000155'
      let res = await operateDetails({ applyId })
      console.log(res, '查看详情')
      if (res.code == 0) {
        this.loanInfo = res.data
      }
    },

    handleOpen() {
      this.dialogVisible = true
      this.init()
    },

    handleClose() {
      this.dialogVisible = false
    },

    // 审核通过
    async handleApproveClick() {
      let dto = {
        isAgree: 0,
        opinion: '',
        taskId: this.selectedLoanRow.taskId
      }
      let res = await approvalRepayment(dto)
      if (res.code == 0) {
        this.$message.success('操作成功')
        this.handleClose()
        this.$emit('confirm')
      }else {
        this.$message.error(res.msg)
      }
    },

    // 审核退回
    handleRejectClick() {
      this.$refs.proDialogRef.handleOpen()
    },

    // 确认退回
    async handleConfirm() {
      let dto = {
        isAgree: 1,
        opinion: this.rejectForm.reason,
        taskId: this.selectedLoanRow.taskId
      }
      let res = await approvalRepayment(dto)
      console.log('res', res)
      if (res.code == 0) {
        this.$message.success('操作成功')
        this.$refs.proDialogRef.handleClose()
        this.handleClose()
        this.$emit('confirm')
      }else {
        this.$message.error(res.msg)
      }
    },

    // 判断是否为图片文件
    isImageFile(fileName) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
      const extension = fileName.split('.').pop().toLowerCase()
      return imageExtensions.includes(extension)
    },

    // 判断是否为PDF文件
    isPdfFile(fileName) {
      return fileName.toLowerCase().endsWith('.pdf')
    },

    // 查看PDF文件
    async viewPdfFile(fileUrl, fileName) {
      try {
        this.pdfFileName = fileName
        this.pdfVisible = true

        // 构建完整的文件URL
        const fullUrl = `${this.baseUrl}admin/file/get?ossFilePath=${fileUrl}`

        // 获取文件内容并转换为Blob
        const response = await fetch(fullUrl)
        const blob = await response.blob()

        // 创建ObjectURL
        const objectUrl = window.URL.createObjectURL(blob)

        // 获取PDF页数
        this.getPdfTotalPages(objectUrl)

        // 创建PDF加载任务
        this.pdfSrc = pdf.createLoadingTask({
          url: objectUrl,
          CMapReaderFactory
        })
      } catch (error) {
        console.error('加载PDF文件失败:', error)
        this.$message.error('PDF文件加载失败，请重试')
      }
    },

    // 获取PDF总页数
    getPdfTotalPages(url) {
      const loadingTask = pdf.createLoadingTask(url)
      loadingTask.promise
        .then(pdf => {
          this.pdfTotalPages = pdf.numPages
        })
        .catch(error => {
          console.error('获取PDF页数失败:', error)
          this.pdfTotalPages = 0
        })
    },

    // 关闭PDF查看器
    closePdfViewer() {
      this.pdfVisible = false
      this.pdfSrc = ''
      this.pdfFileName = ''
      this.pdfTotalPages = 0
    },

    // 下载文件
    downloadFile(fileUrl, fileName) {
      try {
        const fullUrl = `${this.baseUrl}admin/file/get?ossFilePath=${fileUrl}`
        const link = document.createElement('a')
        link.href = fullUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        console.error('下载文件失败:', error)
        this.$message.error('文件下载失败，请重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.loan-detail-container {
  display: flex;
  gap: 20px;
  max-height: 600px;
  overflow-y: auto;
  min-height: 100%;

  .left-section {
    flex: 3;
    padding: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    min-height: 100%;
    overflow-y: auto;
  }

  .right-section {
    flex: 1;
    padding: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    min-height: 100%;
    position: relative;
  }

  .result-info {
    background-color: #f8f8f8;
    border-radius: 4px;
    padding: 15px;
  }

  .result-item {
    display: flex;
    margin-bottom: 15px;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }

    .result-label {
      width: 100px;
      color: #666;
      font-size: 13px;
      font-weight: bold;
      flex-shrink: 0;
    }

    .result-value {
      flex: 1;
      color: #333;
      font-size: 14px;
    }

    .highlight {
      color: #409eff;
      font-weight: bold;
    }

    .result-text {
      color: #999;
      font-size: 12px;
      margin-left: 5px;
    }
  }

  .status-section {
    margin-top: 20px;
    padding: 15px;
    border-radius: 4px;
    background-color: #f0f9ff;
  }

  .status-approved,
  .status-rejected {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .status-approved {
    color: #67c23a;
  }

  .status-rejected {
    color: #f56c6c;
  }

  .status-icon {
    font-size: 18px;
    font-weight: bold;
  }

  .status-text {
    font-size: 14px;
    font-weight: bold;
  }

  .reject-reason {
    font-size: 12px;
    margin-top: 5px;
    color: #f56c6c;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 20px;
    color: #333;
    font-size: 16px;
    font-weight: bold;
  }
}

/* 左侧基本信息 */
.left-section {
  .info-group {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;

    .info-item {
      flex: 1;
      display: flex;
      align-items: center;

      &.full-width {
        flex: 2;
      }

      .info-label {
        width: 120px;
        color: #666;
        font-size: 13px;
        font-weight: bold;
      }

      .info-value {
        flex: 1;
        color: #333;
        font-size: 14px;
      }
    }
  }

  /* 附件资料 */
  .attachment-section {
    margin-top: 30px;

    .attachments {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;

      .attachment-item {
        .attachment-img {
          width: 100px;
          height: 100px;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
        }
      }
    }

    /* 附件文件样式 */
    .attachment-files {
      .Item {
        display: inline-block;
        margin-right: 15px;
        margin-bottom: 15px;
        text-align: center;
        cursor: default;
        vertical-align: top;
      }

      .image-container {
        display: inline-block;
        width: 120px;
        margin-right: 15px;
        margin-bottom: 15px;
        text-align: center;
      }

      .file-image {
        width: 100px;
        height: 100px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        margin-bottom: 5px;
      }

      .file-name {
        font-size: 12px;
        color: #333;
        margin-bottom: 5px;
        word-break: break-all;
      }

      .file-container {
        display: inline-block;
        width: 120px;
        margin-right: 15px;
        margin-bottom: 15px;
        text-align: center;
      }

      .pdf-file-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 100px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        background-color: #f9f9f9;
        cursor: pointer;
        transition: all 0.3s;
        margin-bottom: 5px;

        &:hover {
          border-color: #409eff;
          background-color: #ecf5ff;
        }

        i {
          font-size: 30px;
          color: #ff4d4f;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          color: #333;
        }
      }

      .other-file-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 100px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        background-color: #f9f9f9;
        margin-bottom: 5px;

        i {
          font-size: 30px;
          color: #909399;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          color: #333;
        }
      }

      .file-actions {
        display: flex;
        justify-content: center;
        gap: 5px;
      }

      .download-btn {
        padding: 0;
        font-size: 12px;
        color: #409eff;
      }
    }
  }

  /* PDF查看器样式 */
  .pdf-view-container {
    max-height: 70vh;
    overflow-y: auto;
  }

  .pdf-content {
    width: 90%;
    min-width: 860px;
    margin: 10px auto;
    padding: 10px;
    background: rgba(85, 85, 85, 0.1);
    box-sizing: border-box;
  }

  .pdf-page {
    border: 1px solid #8b8383;
    margin-bottom: 10px;
    width: 100%;
  }

  .pdf-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
    font-size: 16px;
    color: #666;
  }

  /deep/.el-dialog {
    margin-top: 2vh !important;
  }

  /deep/.el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }

  /* 操作按钮样式 - 固定在右侧界面右下方 */
  .action-buttons {
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    z-index: 10;
  }
}
</style>
